// extracted by mini-css-extract-plugin
module.exports = {"background":"style__background__S3aWw","wrapper":"style__wrapper__5jVaE","body":"style__body__Mk0nt","secondaryNav":"style__secondaryNav__wAXmN"};